import * as yup from "yup";
import { HPIRegCheck } from "../helpers";

export const schema = yup.object().shape({
  registration: yup
    .string()
    .required("Please enter registration")
    // strip whitespace
    .transform((val) => val.replace(/\s/g, ""))
    .matches(
      HPIRegCheck,
      "Please make sure your registration is in the correct format"
    )
    .nullable()
});
